import './JiraCredentialsUpdate.scss';
import { CloseOutlined } from '@ant-design/icons';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { JiraCredentialsForm } from './JiraCredentialsForm';
import { jiraIntegrationSelectors } from './@arch/selectors';
import { Button } from 'antd';
import { COPY_SPECIFIC, INTEGRATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
import { useAction, useCurrentUser, useSonarSelector } from '@hooks';
export const JiraCredentialsUpdate = ({ form, onClose }) => {
    const [disabled, setDisabled] = useState(true);
    const isIntegrationRequested = useSonarSelector(jiraIntegrationSelectors.isRequested);
    const deleteJiraCredentials = useAction(integrationsActions.requestDeleteJiraCredentials);
    const { customerId } = useCurrentUser();
    const onSubmit = useCallback(() => {
        form.submit();
        onClose();
    }, [form, onClose]);
    const onCancel = useCallback(() => {
        form.resetFields();
        setDisabled(true);
        onClose();
    }, [form, onClose]);
    const onDelete = useCallback(() => {
        deleteJiraCredentials({ customerId });
        onClose();
    }, [customerId, deleteJiraCredentials, onClose]);
    const onUpdate = useCallback(() => {
        setDisabled(false);
    }, []);
    return (React.createElement("div", { className: 'jira-popover' },
        React.createElement("button", { className: 'popover-close', type: 'button' },
            React.createElement(CloseOutlined, { onClick: onCancel })),
        React.createElement("div", { className: 'jira-popover-header' },
            React.createElement("div", { className: 'h3' }, INTEGRATIONS_COPY.EDIT_JIRA_SETTINGS)),
        React.createElement("div", { className: 'jira-popover-body' },
            React.createElement(JiraCredentialsForm, { form: form, onUpdate: onUpdate })),
        React.createElement("div", { className: 'jira-popover-footer' },
            React.createElement(Button, { danger: true, onClick: onDelete }, COPY_SPECIFIC.DELETE_INTEGRATION),
            React.createElement("div", null,
                React.createElement(Button, { onClick: onCancel }, COPY_SPECIFIC.CANCEL),
                React.createElement(Button, { disabled: disabled, id: 'update-jira-integration', loading: isIntegrationRequested, onClick: onSubmit, type: 'primary' }, COPY_SPECIFIC.UPDATE)))));
};
